import { useMemo } from 'react';
import { nowInstant, plainDateFrom, toPlainDate, type Temporal } from '@insio/dates';
import { useTimeZone } from '@insio/ui-toolkit';

/** Today in the account's time zone; the instance is stable for the whole day. */
export function useToday(): Temporal.PlainDate {
  const day = toPlainDate(nowInstant(), useTimeZone()).toString();
  return useMemo(() => plainDateFrom(day), [day]);
}
